<script lang="ts" setup>
import 'vue3-toastify/dist/index.css'
import { onMounted, ref, computed } from 'vue';
import store from '@/store'
import { useRouter } from "vue-router";

const router = useRouter();
const currentOrder = computed(() => store.state.currentOrder);
const items = ref([] as any[]);

async function refreshData() {
    items.value = JSON.parse(currentOrder.value.items)
}

function redirectTo(routeName: string, mailItemDescription: string) {
    let id: string | null = null;

    id = mailItemDescription.match(/\d+/)?.[0] || null;

    router.push({ name: routeName, params: { id: id } })
}

onMounted(async () => {
    await refreshData();
})
</script>

<template>
    <div class="bg-white rounded-xl shadow p-6 border border-gray-100 max-w-2xl mx-auto flex flex-col gap-6">
        <div class="flex items-center gap-3 mb-2">
            <svg class="w-6 h-6 text-pink-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"
                title="Zásielky">
                <rect x="3" y="5" width="18" height="14" rx="3" stroke="currentColor" stroke-width="2" fill="none" />
                <path d="M3 7l9 6 9-6" stroke="currentColor" stroke-width="2" fill="none" />
            </svg>
            <span class="text-xl font-bold text-slate-900" title="Popis objednávky">{{ currentOrder.description
            }}</span>
            <span class="ml-auto text-xl font-bold text-teal-700" title="Celková suma">{{ currentOrder.amount }}€</span>
        </div>
        <div class="font-semibold text-slate-700 flex items-center gap-2 mb-2">
            <svg class="w-5 h-5 text-teal-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"
                title="Zoznam zásielok">
                <rect x="4" y="4" width="16" height="16" rx="3" stroke="currentColor" stroke-width="2" fill="none" />
                <path d="M8 12h8" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
            Zoznam zásielok
        </div>
        <div>
            <table class="min-w-full divide-y divide-gray-200">
                <tbody>
                    <tr v-for="item in items" :key="item.description" class="hover:bg-teal-50 transition">
                        <td class="pr-8 py-2 text-gray-800">{{ item.description }}</td>
                        <td>
                            <button v-if="!item.description.includes('sídla')" type="button"
                                class="inline-flex items-center gap-2 py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
                                @click="redirectTo('Detail zásielky', item.description)" title="Prejsť na zásielku">
                                <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2"
                                    viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
                                </svg>
                                <span class="sr-only">Prejsť na zásielku</span>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>